/** Extra context attached to a {@link FlagServiceError}. */
export interface FlagServiceErrorOptions {
  /** HTTP status code, when the failure was an HTTP error response. */
  status?: number;
  /** The underlying error (network failure, abort, …). */
  cause?: unknown;
}

/**
 * Thrown by {@link FlagServiceClient} when a request to the flagservice fails
 * at the transport level — a network error, a timeout, or a non-2xx response.
 *
 * Note: this is distinct from a *flag* evaluation error. A reachable server that
 * returns an evaluation whose reason is `ERROR`/`FLAG_NOT_FOUND` does not throw;
 * the provider surfaces that as an OpenFeature `errorCode` on the resolution.
 */
export class FlagServiceError extends Error {
  /** HTTP status code, when the failure was an HTTP error response. */
  readonly status?: number;

  constructor(message: string, options: FlagServiceErrorOptions = {}) {
    super(message, { cause: options.cause });
    this.name = "FlagServiceError";
    this.status = options.status;
  }
}
